var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.headerClasses},[(_vm.title)?_c('h2',{class:_vm.titleClasses},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('p',{class:_vm.subtitleClasses},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }